import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { initializeI18n, normalizeLocale, useUiStore } from '@bms/common';
import { ThemeProvider } from './providers/ThemeProvider';
import { FlavourProvider } from './providers/FlavourProvider';
import { registerUserTranslations } from './i18n';
import { Toaster } from '@/components/ui/sonner';
import App from './App';
import './index.css';

// Initialize i18n
const storedLocale = useUiStore.getState().locale;
const initialLocale = normalizeLocale(storedLocale);
if (storedLocale !== initialLocale) useUiStore.getState().setLocale(initialLocale);
initializeI18n(initialLocale);
registerUserTranslations();

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      retry: 1,
    },
  },
});

function Root() {
  return (
    <ThemeProvider>
      <FlavourProvider>
        <App />
        <Toaster />
      </FlavourProvider>
    </ThemeProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <Root />
    </BrowserRouter>
  </QueryClientProvider>
);
